<script setup lang="ts" generic="T extends ISmartFilterColumn">
import type { ISmartFilterColumn } from '@modules/smart-filters/types';
import VIconButton from '@components/buttons/VIconButton/VIconButton.vue';
import { QA_TABLES } from '@modules/tables/constants';

import type { ISmartFilterColumnEmits, ISmartFilterColumnProps } from './types';

defineProps<ISmartFilterColumnProps>();
const emit = defineEmits<ISmartFilterColumnEmits>();

function clearColumnData(ev: Event): void {
  ev.stopPropagation();
  emit('clear-column-data');
}
</script>

<template>
  <div v-data-qa-auto-id="'VSmartFilterColumn'"
    class="flex w-full items-center justify-between gap-2 !pl-3"
  >
    <i
      v-if="!column.isEmpty"
      class="pi pi-circle-fill absolute inset-y-0 left-[9px] m-auto h-[4px] text-[4px] text-primary"
    />
    <span
      v-if="translationPath"
      class="break-words"
    >{{ $t(`${translationPath}.${column.id}`) }}</span>
    <span v-else>{{ column.label }}</span>
    <VIconButton
      v-if="!column.isEmpty && !isSupervision"
      v-data-test="{ el: QA_TABLES.filterColumnClear }"
      icon="pi-times"
      class="flex-none"
      size="small"
      @click="clearColumnData"
    />
  </div>
</template>
